import { z } from 'zod';
export const AdfMarkSchema = z.object({
    type: z.string(),
    attrs: z.record(z.string(), z.unknown()).optional(),
});
export const AdfNodeSchema = z.object({
    type: z.string(),
    attrs: z.record(z.string(), z.unknown()).optional(),
    get content() {
        return z.array(AdfNodeSchema).optional();
    },
    marks: z.array(AdfMarkSchema).optional(),
    text: z.string().optional(),
});
export const AdfDocumentSchema = z.object({
    type: z.literal('doc'),
    version: z.number().int(),
    content: z.array(AdfNodeSchema),
});
/** Узлы, которые умеет редактировать наш редактор. Остальное сохраняется как есть. */
export const EDITABLE_ADF_NODES = [
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'listItem',
    'codeBlock',
    'blockquote',
    'rule',
    'hardBreak',
    'text',
];
/** Начертания, которые умеет редактор. */
export const EDITABLE_ADF_MARKS = ['strong', 'em', 'strike', 'code', 'link'];
export function isEditableAdfNode(type) {
    return EDITABLE_ADF_NODES.includes(type);
}
export function isEditableAdfMark(type) {
    return EDITABLE_ADF_MARKS.includes(type);
}
/** Пустой документ: Jira не принимает описание без корневого узла. */
export function emptyAdfDocument() {
    return { type: 'doc', version: 1, content: [] };
}
/** Плоский текст документа — для поиска, заголовков и озвучивания скринридером. */
export function adfToPlainText(doc) {
    if (!doc)
        return '';
    const parts = [];
    const walk = (node) => {
        if (typeof node.text === 'string')
            parts.push(node.text);
        if (node.content) {
            for (const child of node.content)
                walk(child);
            if (node.type === 'paragraph' || node.type === 'heading')
                parts.push('\n');
        }
    };
    walk(doc);
    return parts.join('').replace(/\n{3,}/g, '\n\n').trim();
}
//# sourceMappingURL=adf.js.map